import { render, staticRenderFns } from "./EncuestaPreguntas.vue?vue&type=template&id=ade27342"
import script from "./EncuestaPreguntas.vue?vue&type=script&lang=js"
export * from "./EncuestaPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports